import 'bootstrap-slider';
import _slider from './_slider';
import {isTouchDevice} from '../common/_globals';

export default function(){
    _slider.initOnce();
    // Init sliders
    $('.number-slider .bootstrap-slider').each(function () {
        const itemElementID = $(this).data("item-element-id");
        let values = $(this).data("slider-values");
        const min = $(this).data("slider-min");
        const max = $(this).data("slider-max");
        const step = $(this).data("slider-step");

        if (values === undefined) {
            values = [];
            for (let val = min; val <= max; val += step) {
                values.push(val);
            }
        }
        const slider: JQuery = _slider.bootstrapSlider($(this), [{
            tooltip: 'hide', // @todo Remove this when bootstrap-slider supports BS5, see https://github.com/cloud-solutions/surveylab/issues/1318
            ticks: [min, max]
        }]);
        const sliderElement = _slider.bootstrapSlider(slider, ['getElement']);
        const $sliderHandle = $('.min-slider-handle', sliderElement);
        const $sliderRow = $(sliderElement).closest('.item-row');

        // Set current value
        const $inputElement = $('#' + itemElementID, $(this).closest('.slider-column'));
        const hasValue = (<string>$inputElement.val()).length > 0;
        if (hasValue) {
            _slider.bootstrapSlider(slider, ['setValue', $inputElement.val()]);
        } else {
            //_slider.hideHandle(slider);
            _slider.bootstrapSlider(slider, ['setValue', min]);
            $(sliderElement).addClass('no-selection');
        }

        if (isTouchDevice()) {
            _slider.resetOnSwipe();
        }

        slider.on('slideStart', function (event: JQuery.Event) {
            $(sliderElement).removeClass('no-selection');
            _slider.onSlideStart(slider, sliderElement, $sliderHandle, $sliderRow, min, (<any>event).value);
        }).on('change', function () {
            const val = _slider.bootstrapSlider(slider, ['getValue']);
            _slider.setValue(slider, val);
        }).on('slideStop', function () {
            _slider.sliderIsSliding(false);
        });
    });
}